import { SwitchThumb as RadixSwitchThumb, Root, Thumb } from '@radix-ui/react-switch';
import { forwardRef } from 'react';
import classNames from '@/lib/classNames';

const SwitchThumb = forwardRef<React.ElementRef<typeof Root>, React.ComponentPropsWithoutRef<typeof Root>>(({ className, ...props }, ref) => (
    <Thumb
        className={classNames(
            'pointer-events-none block h-4 w-4 rounded-full bg-primary shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-1',
            className
        )}
        {...props}
        ref={ref}
    ></Thumb>
));

SwitchThumb.displayName = RadixSwitchThumb.displayName;

const Switch = forwardRef<React.ElementRef<typeof Root>, React.ComponentPropsWithoutRef<typeof Root>>(({ className, ...props }, ref) => (
    <Root
        className={classNames(
            'bg-white peer inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50  data-[state=unchecked]:bg-input',
            className
        )}
        {...props}
        ref={ref}
    ></Root>
));
Switch.displayName = Root.displayName;

export { Switch, SwitchThumb };
